T.ContactForm = Class(
	/**
	 * @lends {T.CorporateForm#}
	 */
	{
		__construct() {
			this.node = mkE({
				tag: 'form',
				className: 'corporate-contacts-form bs-form',
				attr: {
					method: 'post'
				},
				prop: {
					onsubmit: this._onSubmit
				}
			});

			this._draw();
		},

		_draw() {
			clearNode(this.node);

			this._fields = {};

			this._drawPersonalInfo();
			this._drawGameInfo();
			this._drawBottom();
		},

		_drawBlock( title, content ) {
			mkE({
				tag: 'div',
				className: 'corporate-contacts-block',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-3 corporate-contacts-caption',
								text: title
							},
							{
								tag: 'div',
								className: 'col-12 col-md-9 col-lg-6',
								els: [
									content
								]
							}
						]
					}
				]
			}).append(this.node);
		},

		_drawPersonalInfo() {
			this._fields['full_name'] = new T.BS.Input({
				label: D.Lang.get('corporate-form.name'),
				name: 'full_name',
				attr: {
					placeholder: D.Lang.get('corporate-form.name.placeholder')
				}
			});
			this._fields['phone'] = new T.BS.Input({
				label: D.Lang.get('corporate-form.phone'),
				name: 'phone_default',
				type: 'tel',
				phone: {
					hiddenInput: 'phone',
					preferredCountries: D.Lang.get('corporate-form.phone.preffered').split(',')
				}
			});
			this._fields['email'] = new T.BS.Input({
				label: D.Lang.get('corporate-form.email'),
				name: 'email',
				type: 'email',
				attr: {
					placeholder: D.Lang.get('corporate-form.email.placeholder')
				}
			});
			let content = mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									this._fields['full_name'].node
								]
							},
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									this._fields['phone'].node
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									this._fields['email'].node
								]
							}
						]
					}
				]
			});
			this._drawBlock(D.Lang.get('corporate-form.personal-info'), content);
		},

		_drawGameInfo() {
			this._fields['location'] = new T.BS.Input({
				label: D.Lang.get('corporate-form.location'),
				name: 'location',
				attr: {
					placeholder: D.Lang.get('corporate-form.location.placeholder')
				}
			});
			this._fields['message'] = new T.BS.Textarea({
				label: D.Lang.get('corporate-form.message'),
				name: 'message',
				attr: {
					placeholder: D.Lang.get('corporate-form.message.placeholder'),
					rows: 4
				}
			});
			let content = mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									this._fields['location'].node
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									this._fields['message'].node
								]
							}
						]
					}
				]
			});
			this._drawBlock(D.Lang.get('corporate-form.game-info'), content);
			this._drawBlock('', {
				tag: 'div',
				className: 'discount-code',
				els: [
					{
						tag: 'div',
						className: 'discount-code-toggle',
						els: [
							{
								tag: 'a',
								onclick: () => {
									if( this._discountNode.style.display ) {
										this._discountNode.style.display = '';
									} else {
										this._discountNode.style.display = 'block';
										this._fields['code'].focus();
									}
								},
								text: D.Lang.get('corporate-form.code.title')
							}
						]
					},
					this._discountNode = mkE({
						tag: 'div',
						className: 'discount-code-input',
						els: [
							this._fields['code'] = new T.BS.Input({
								name: 'code',
								attr: {
									placeholder: D.Lang.get('corporate-form.code.placeholder')
								}
							})
						]
					})
				]
			});
		},

		_drawBottom() {
			mkE({
				tag: 'div',
				className: 'bs-row corporate-contacts-bottom',
				els: [
					{
						tag: 'div',
						className: 'col-12 col-md-6 offset-md-3',
						els: [
							{
								tag: 'div',
								className: 'form-button',
								els: [
									{
										tag: 'button',
										className: 'button button-pink',
										text: D.Lang.get('corporate-form.send')
									},
									this._formMessage = mkE({
										tag: 'div',
										className: 'form-message'
									})
								]
							},
							{
								tag: 'div',
								className: 'form-disclaimer',
								els: [
									D.Lang.get('corporate-form.personal-data'),
									' ',
									{
										tag: 'a',
										text: D.Lang.get('corporate-form.privacy-policy'),
										target: '_blank',
										href: D.url('privacy-policy')
									}
								]
							}
						]
					}
				]
			}).append(this.node);
		},

		clearForm() {
			this.node.reset();
		},

		showSuccess() {
			const node = mkE({
				tag: 'span',
				text: D.Lang.get('contact-form.thanks')
			}).append(this._formMessage);
			nl2br(node);
			D.scrollIntoView(this._formMessage);
			const get = new Get();
			get.add('send-success', '');
			Section.replaceUrl(get.toUrl());
		},

		showError( response ) {
			if( response.errors ) {
				let hasError = false;
				if( response.errors.full_name ) {
					this._fields['full_name'].error(D.Lang.get('corporate-form.errors.name'));
					hasError = true;
				}
				if( response.errors.phone ) {
					this._fields['phone'].error(D.Lang.get('corporate-form.errors.phone'));
					hasError = true;
				}
				if( response.errors.email ) {
					this._fields['email'].error(D.Lang.get('corporate-form.errors.email'));
					hasError = true;
				}
				if( response.errors.location ) {
					this._fields['location'].error(D.Lang.get('corporate-form.errors.location'));
					hasError = true;
				}
				if( hasError ) {
					this._scrollToError();
					return;
				}
			}
			alert(D.Lang.get('corporate-form.errors.default'));
		},

		_onSubmit() {
			if( this._isSubmitting ) {
				return false;
			}
			clearNode(this._formMessage);
			this._isSubmitting = true;
			let hasError = false;
			let values = {};
			for( const field in this._fields ) {
				this._fields[field].error(null);
				values[field] = this._fields[field].value();
			}
			if( !values.full_name ) {
				this._fields['full_name'].error(D.Lang.get('corporate-form.errors.name'));
				hasError = true;
			}
			if( !values.phone ) {
				this._fields['phone'].error(D.Lang.get('corporate-form.errors.phone'));
				hasError = true;
			}
			if( !values.email ) {
				this._fields['email'].error(D.Lang.get('corporate-form.errors.email'));
				hasError = true;
			}
			if( hasError ) {
				this._isSubmitting = false;
				this._scrollToError();
				return false;
			}
			let data = new FormData();
			for( const field in values ) {
				if( !values.hasOwnProperty(field) ) {
					continue;
				}
				data.append(field, values[field]);
			}
			data.append('json', '1');
			fetch("/api/contact_submit.php", {
				body: data,
				method: 'POST'
			})
				.then(response => response.json())
				.then(response => {
					this._isSubmitting = false;
					if( response.error ) {
						this.showError(response);
						return;
					}
					this.showSuccess();
					this.clearForm();
				})
				.catch(error => {
					this._isSubmitting = false;
					alert(D.Lang.get('corporate-form.errors.default'));
				});
			return false;
		},

		_scrollToError() {
			let error = this.node.querySelector(".invalid-feedback:not(:empty)").closest(".form-group");
			if( error ) {
				D.scrollIntoView(error);
			}
		}
	},
	mkE.Base
)